export default __webpack_public_path__ + "static/media/fabia.369949ad.png";